import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class SettingsBillingStripeRoute extends Route {
	@service('billing') declare billingService: Service.Billing;
	@service('navigation') declare navigationService: Service.Navigation;

	override afterModel() {
		this.navigationService.replaceRoute('settings.billing.index');
		this.billingService.changePayment();
	}
}
